import * as React from 'react';

function SvgSort(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg height="1em" viewBox="0 0 13 12" width="1em" {...props}>
      <path
        d="M4.76 9.084a.683.683 0 010 .942l-1.714 1.779a.63.63 0 01-.908 0L.424 10.027a.683.683 0 01-.168-.645c.059-.23.233-.41.455-.472s.46.005.622.174l.616.64V.667c0-.369.288-.667.643-.667.355 0 .642.298.642.667v9.057l.616-.64a.63.63 0 01.909 0zm2.091-6.168a.683.683 0 010-.942L8.564.194a.63.63 0 01.909.001l1.714 1.778a.685.685 0 01.168.645.658.658 0 01-.455.472.627.627 0 01-.622-.174l-.616-.64v9.057a.655.655 0 01-.643.667.655.655 0 01-.643-.667V2.276l-.616.64a.63.63 0 01-.909 0z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  );
}

export default SvgSort;
